<script>
import Twilio from "./Twilio";
import Jitsi from "./Jitsi";
import { videoRoomEngine } from "@/services/config";

export default {
  name: "VideoRoom",

  props: {
    patientId: {
      type: String,
      require: true,
    },
    appointmentId: {
      type: String,
    },
    /**
     * @description Propaga el auto-join al engine de video: si es true,
     * la videollamada arranca sola al montar, sin click en "Unirse".
     */
    autoJoin: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Twilio,
    Jitsi,
  },

  data() {
    return {
      roomId: "",
      isLoading: false,
      isAudioEnabled: true,
      isVideoEnabled: true,
      room: "",
      state: "pending",
      videoRoomEngine,
    };
  },
};
</script>

<!-- TODO: Read env var to decide which video provider to use -->
<template lang="pug">
span
  Jitsi(
    v-if="videoRoomEngine === 'jitsi'"
    :patientId="patientId"
    :appointmentId="appointmentId"
    :autoJoin="autoJoin"
  )
  Twilio(
    v-if="videoRoomEngine === 'twilio'"
    :patientId="patientId"
    :appointmentId="appointmentId"
    :autoJoin="autoJoin"
  )
</template>

<style lang="scss"></style>
